import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminComandas() {
  const [comandas, setComandas] = useState([]);
  const [status, setStatus] = useState('fechada');
  const [detalhes, setDetalhes] = useState(null);
  const [loading, setLoading] = useState(false);

  const carregar = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/comandas?status=${status}`);
      setComandas(r.data);
    } catch {} finally { setLoading(false); }
  };

  const abrirDetalhes = async (id) => {
    try {
      const r = await api.get(`/comandas/${id}`);
      setDetalhes(r.data);
    } catch {}
  };

  useEffect(() => { carregar(); }, [status]);

  const totalDia = comandas
    .filter(c => new Date(c.fechada_em || c.aberta_em).toDateString() === new Date().toDateString())
    .reduce((s, c) => s + parseFloat(c.total || 0), 0);

  const totalGeral = comandas.reduce((s, c) => s + parseFloat(c.total || 0), 0);

  const fmt = (d) => d ? new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-';

  const statusLabel = { aberta: '🟢 Aberta', fechada: '✅ Fechada', cancelada: '❌ Cancelada' };

  const formasPagLabel = {
    dinheiro: '💵 Dinheiro', pix: '📱 PIX',
    cartao_credito: '💳 Crédito', cartao_debito: '💳 Débito', outro: '📌 Outro'
  };

  return (
    <div style={{ padding: 16, maxWidth: 1000, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 16 }}>📋 Comandas</h1>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {['aberta', 'fechada', 'cancelada'].map(s => (
          <button key={s} onClick={() => setStatus(s)} style={{
            padding: '8px 14px', border: 'none', borderRadius: 6, cursor: 'pointer',
            fontSize: 13, fontWeight: 600, color: '#fff',
            background: status === s ? 'var(--orange)' : 'var(--bg3)'
          }}>{statusLabel[s]}</button>
        ))}
      </div>

      {/* Resumo */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
        <div style={{ background: 'var(--bg3)', padding: 14, borderRadius: 8, border: '1px solid var(--border)' }}>
          <div style={{ fontSize: 11, color: 'var(--text2)' }}>Total (hoje)</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: 'var(--orange)' }}>R$ {totalDia.toFixed(2).replace('.', ',')}</div>
        </div>
        <div style={{ background: 'var(--bg3)', padding: 14, borderRadius: 8, border: '1px solid var(--border)' }}>
          <div style={{ fontSize: 11, color: 'var(--text2)' }}>Total (filtro)</div>
          <div style={{ fontSize: 20, fontWeight: 800 }}>R$ {totalGeral.toFixed(2).replace('.', ',')}</div>
        </div>
      </div>

      {loading ? <div style={{ textAlign: 'center', padding: 40 }}>Carregando...</div>
        : comandas.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Nenhuma comanda</div>
        : comandas.map(c => (
          <div key={c.id} onClick={() => abrirDetalhes(c.id)} style={{
            background: 'var(--bg3)', padding: 12, borderRadius: 8,
            marginBottom: 8, border: '1px solid var(--border)', cursor: 'pointer',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center'
          }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700 }}>
                {c.mesa_numero.match(/^\d+$/) ? `Mesa ${c.mesa_numero}` : c.mesa_numero}
                {c.nome_cliente && <span style={{ color: 'var(--text2)', fontWeight: 400 }}> · {c.nome_cliente}</span>}
              </div>
              <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>
                #{c.id} · {c.funcionario_nome} · {fmt(c.fechada_em || c.aberta_em)}
              </div>
            </div>
            <div style={{ fontSize: 15, fontWeight: 800, color: 'var(--orange)' }}>
              R$ {parseFloat(c.total).toFixed(2).replace('.', ',')}
            </div>
          </div>
        ))}

      {/* Modal detalhes */}
      {detalhes && (
        <div onClick={() => setDetalhes(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 100
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: 'var(--bg2, #1a1a1a)', borderRadius: 12, padding: 20,
            maxWidth: 500, width: '100%', maxHeight: '90vh', overflow: 'auto',
            border: '1px solid var(--border)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontSize: 18, fontWeight: 800 }}>
                {detalhes.mesa_numero.match(/^\d+$/) ? `Mesa ${detalhes.mesa_numero}` : detalhes.mesa_numero}
              </h3>
              <button onClick={() => setDetalhes(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer' }}>×</button>
            </div>

            <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 14 }}>
              #{detalhes.id} · {statusLabel[detalhes.status]}<br />
              Atendente: {detalhes.funcionario_nome}<br />
              {detalhes.nome_cliente && <>Cliente: {detalhes.nome_cliente}<br /></>}
              Aberta: {fmt(detalhes.aberta_em)}<br />
              {detalhes.fechada_em && <>Fechada: {fmt(detalhes.fechada_em)}</>}
            </div>

            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: 'var(--text2)' }}>ITENS</div>
            {detalhes.itens.map(i => (
              <div key={i.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 13 }}>{i.quantidade}× {i.produto_nome}</span>
                  <span style={{ fontSize: 13, fontWeight: 700 }}>R$ {parseFloat(i.subtotal).toFixed(2).replace('.', ',')}</span>
                </div>
                {i.observacao && <div style={{ fontSize: 11, color: 'var(--orange)', marginTop: 2 }}>📝 {i.observacao}</div>}
              </div>
            ))}

            {detalhes.pagamentos && detalhes.pagamentos.length > 0 && (
              <>
                <div style={{ fontSize: 13, fontWeight: 700, margin: '14px 0 8px', color: 'var(--text2)' }}>PAGAMENTOS</div>
                {detalhes.pagamentos.map(p => (
                  <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13 }}>
                    <span>{formasPagLabel[p.forma]}</span>
                    <span style={{ fontWeight: 700, color: '#22c55e' }}>R$ {parseFloat(p.valor).toFixed(2).replace('.', ',')}</span>
                  </div>
                ))}
              </>
            )}

            <div style={{ marginTop: 14, paddingTop: 12, borderTop: '2px solid var(--border)', display: 'flex', justifyContent: 'space-between', fontSize: 16, fontWeight: 800 }}>
              <span>TOTAL</span>
              <span style={{ color: 'var(--orange)' }}>R$ {parseFloat(detalhes.total).toFixed(2).replace('.', ',')}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
